<template>
  <div class="">
    <v-header ref="dudu"></v-header>
    <div class="beijngsd">
      <span></span>
      性格测评
      <span></span>
    </div>
    <div class="manpin">
      <div class="main centen container">
        <leftmenu></leftmenu>
        <!-- 在class为main_r里面写页面就行 -->
        <div class="main_r">
          <div class="mainr_top">
            <img src="../images/geren16.png">性格测评
          </div>

          <!--性格评测-->
          <div class="xingge">
            <img src="../images/4380.png">
            <div class="text">
              <h4>霍兰德职业兴趣测试前须知</h4>
              <p>1、参加测试的人员请务必诚实、独立地回答问题，只有如此，才能得到有效的结果。</p>
              <p>2、《职业兴趣测评分析报告》展示的是你的性格倾向，而不是你的知识、技能、经验。</p>
              <p>
                3、测评的结果没有好坏，只有不同。每一种结果特征都有其价值和优点，也有缺点和需要注意的地方。清楚地了解自己的优劣势，有利于更好地发挥自己的特长，而尽可能的在为人处事中避免自己的劣势，更好地和他人相处，更好地作重要的决策。
              </p>
              <p>4、本测试共60题；需时约20分钟。所有题目没有对错之分，请根据自己的实际情况选择
              <p>5、只要你是认真、真实地填写了测试问卷，那么通常情况下你都能得到一个确实和你的性格相匹配的类型。希望你能从中或多或少地获得一些有益的信息。</p>
              <div class="open" style="cursor: pointer;" @click="to">开始测评</div>

              <router-link style="margin-top: 30px;font-size: 20px;
              color: #409eff;display: block;
              text-decoration: underline;" to="./tcphistory">测评报告</router-link>
            </div>
          </div>
          <!--性格评测end-->
        </div>
      </div>
    </div>
    <item7></item7>
    <toast :title="title" :message="message" v-if="toastflag" @close="toastflag = false" :fun="fun" :flag="toastflag"
      :btn="que" @go="go">
    </toast>
  </div>
</template>

<script>
  import vHeader from '../../components/vHeader.vue'
  import item7 from '../../components/item7.vue'
  import leftmenu from '../../components/leftmenu.vue'
  import toast from '../../components/toast.vue'
  export default {
    name: "",
    components: {
      vHeader,
      item7,
      leftmenu,
      toast
    },
    data() {
      return {

        value: '',
        radio: '1',
        radio2: "1",
        duichu: false,
        dusnhhwe: true,
        title: "",
        fun: 'go',
        message: "",
        toastflag: false,
        que: 'que'


        // 手机号!/^1[3456789]\d{9}$/.test(this.dinahua)
      }
    },
    methods: {
      to() {
        this.$router.push('/kaishicheping')
      },
      go() {
        console.log(44)
        this.$router.push('/grzx_wdxs')
      }

    },
    created() {
      console.log(this.$utils.getlocalStorage('scoreInfo'))
      if (this.$utils.getlocalStorage('userInfo').userRole == '3') {
        if (this.$utils.getlocalStorage('scoreInfo') == null || this.$utils.getlocalStorage('scoreInfo') == undefined ||
          this.$utils.getlocalStorage('scoreInfo') == '') {
          this.title = "温馨提醒"
          this.message = '请添加学生再使用!'
          this.toastflag = true
          this.fun = "go"
          this.que = 'que'
        }
      }

    }




  }
</script>

<style scoped>
  .beijngsd {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100px;
    margin-top: 70px;
    background: url(../../assets/gerenzhongxin/geren21.png)no-repeat;
    background-size: 100% 100%;
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
  }

  .beijngsd span {
    display: flex;
    width: 44px;
    height: 2px;
    opacity: 0.48;
    border-radius: 1px;
    background-color: #FFFFFF;
  }

  .beijngsd span:nth-of-type(1) {
    margin-right: 14px;
  }

  .beijngsd span:nth-of-type(2) {
    margin-left: 14px;
  }

  .centen {
    width: 1280px;
    margin: 0 auto;
  }

  .manpin {
    width: 100%;
    height: auto;
    padding: 40px 0;
    box-sizing: border-box;
    background: #ebeef5d6;
  }

  .main {
    padding-bottom: 40px;
    display: flex;
    justify-content: space-between;
  }



  .beijngsdtu {
    background: url(../../assets/gerenzhongxin/geren26.png)no-repeat;
    background-size: 100% 100%;
  }

  .main_r {
    width: 1050px;
    height: 878px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;
  }

  .mainr_top {
    width: 100%;
    height: 68px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.10196078431372549);
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
  }

  .mainr_top img {
    width: 7px;
    height: 24px;
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/mine/h_wdceping.vue